import * as tslib_1 from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { env } from '@ivy/fts/envInfo/envInfo';
let Collocation = class Collocation extends Vue {
    constructor() {
        super(...arguments);
        this.vip_config = null;
        this.emptyAlbum = [
            {
                id: 'empty1',
                pic_url: require('../../images/pic-two.png'),
                title: '这里是搭配售套餐名字，最多显示2行',
                sub_title: '这里是搭配售套餐简介',
                audio_names: [],
                goods: [
                    {
                        cover: require('../../images/pic-two.png'),
                        title: '商品名称商品名称商品2行2222222',
                    },
                    {
                        cover: require('../../images/pic-two.png'),
                        title: '1111111111',
                    },
                    {
                        cover: require('../../images/pic-two.png'),
                        title: '1111111111',
                    },
                    {
                        cover: require('../../images/pic-two.png'),
                        title: '1111111111',
                    },
                    {
                        cover: require('../../images/pic-two.png'),
                        title: '1111111111',
                    },
                    {
                        cover: require('../../images/pic-two.png'),
                        title: '1111111111',
                    },
                ],
                activity_price: 1.0,
                discount_price: 10,
            },
            {
                id: 'empty2',
                pic_url: require('../../images/pic-two.png'),
                title: '这里是搭配售套餐名字，最多显示2行',
                sub_title: '这里是搭配售套餐简介',
                audio_names: [],
                goods: [
                    {
                        cover: require('../../images/pic-two.png'),
                    },
                ],
                activity_price: 1.0,
                discount_price: 10,
            },
        ];
        this.publishedAlbums = [];
    }
    async getPubAlbums() {
        let audio_ids = this.data.collocations.map(audio => audio.id);
        if (audio_ids && audio_ids.length) {
            let { data } = await this.$axios.get('/api/goods/shop/market/microPage/getCollocationByIds', {
                params: {
                    ids: audio_ids,
                },
            });
            this.publishedAlbums = data;
        }
        else {
            this.publishedAlbums = [];
        }
    }
    async created() {
        this.getPubAlbums();
    }
    get priceAlignStyle() {
        if (this.data.fontAlign === 'center') {
            return {
                'justify-content': 'center',
            };
        }
        return '';
    }
    get priceAlignStyle1() {
        if (this.data.fontAlign === 'center') {
            return {
                'margin-left': '-10px',
            };
        }
        return '';
    }
    getGoodsImg(goods) {
        // return goods.
        return goods.cover;
    }
    get getClass() {
        if (this.canShowWhite && this.data.whiteCard) {
            return 'white-card';
        }
        else {
            return '';
        }
    }
    get noticeStyle() {
        return `background: ${this.vip_config.back_color};
           color:${this.vip_config.font_color};
           border-radius: 0px ${this.data.radius}px 0px 10px`;
    }
    get coursesBoxStyle() {
        return {
            'background-color': this.data.bgColor,
            padding: `0 ${this.data.compMargin}px`,
        };
    }
    get canShowWhite() {
        return true;
    }
    get courseBoxStyle() {
        return {
            margin: `${this.data.spacing / 2}px 0`,
            'border-radius': this.data.radius + 'px',
            background: '#fff',
            padding: '0px',
        };
    }
    async toDetail(data) {
        if (env.type === 'ivydad') {
            let goodsUrl = `${window.origin}/goods/goodsSalesDetail?cid=${data.id}&navBarHide=1`;
            await env.init();
            await env.commonJump(`ivydadreadtool://h5?url=${encodeURIComponent(goodsUrl)}`);
        }
        else {
            window.location.href = `${window.origin}/goods/goodsSalesDetail?cid=${data.id}`;
        }
    }
    get courseItemStyle() {
        if (this.data.whiteCard) {
            return {
                margin: `${this.data.spacing / 2}px 0`,
                'border-radius': this.data.radius + 'px',
                background: '#fff',
            };
        }
        else {
            return {
                margin: `${this.data.spacing / 2}px 0`,
                background: this.data.bgColor || '#f5f6f6',
            };
        }
    }
    get coverStyle() {
        return {
            'border-radius': this.data.radius + 'px',
            'object-fit': this.data.filling,
        };
    }
    get textStyle() {
        if (this.data.lineRule === 'list') {
            return {
                'font-weight': this.data.fontWeight,
            };
        }
        else {
            return {
                'text-align': this.data.fontAlign,
                'font-weight': this.data.fontWeight,
            };
        }
    }
    get textDescStyle() {
        return {
            'text-align': this.data.fontAlign,
        };
    }
    get hasAlbum() {
        return this.data.collocations && this.data.collocations.length;
    }
    get courseList() {
        return this.hasAlbum ? this.publishedAlbums : this.emptyAlbum;
    }
};
tslib_1.__decorate([
    Prop()
], Collocation.prototype, "data", void 0);
tslib_1.__decorate([
    Prop({ default: () => { } })
], Collocation.prototype, "config", void 0);
tslib_1.__decorate([
    Watch('data.collocations')
], Collocation.prototype, "getPubAlbums", null);
Collocation = tslib_1.__decorate([
    Component({})
], Collocation);
export default Collocation;
